import { type ReactNode } from 'react';
import Toggle from '@/components/Toggle';
import { BoltFillColorMintIcon, BoltFillColorVioletIcon } from '@/icons';
import { NewChip } from '@/shared/components/Chip/NewChip';
import { type PlanType } from '@/types';
import { cn } from '@/utils';
export const ToggleOptionContainer = ({
  optionIcon,
  optionTitle,
  optionDescription,
  isOn,
  onToggle,
  planType,
  isBadgeVisible,
  isNew = false,
  disabled = false,
  renderToggle,
  descriptionPlacement = 'below'
}: {
  optionIcon: ReactNode;
  optionTitle: ReactNode;
  optionDescription: string;
  /**
   * 기본 토글 상태. `renderToggle`로 커스텀 컨트롤(예: Select)을 렌더할 때는 생략 가능.
   */
  isOn?: boolean;
  /**
   * 행 클릭 시 호출. 커스텀 컨트롤이 자체적으로 상호작용을 처리하면 생략 가능.
   */
  onToggle?: () => void;
  planType: PlanType;
  isBadgeVisible: boolean;
  isNew?: boolean;
  disabled?: boolean;
  renderToggle?: (toggle: ReactNode) => ReactNode;
  descriptionPlacement?: 'below' | 'text';
}) => {
  const toggle = <span className="relative inline-flex h-[24px] w-[42px] shrink-0 items-center">
      <Toggle isOn={isOn ?? false} setIsOn={() => {}} disabled={disabled} />
    </span>;
  const description = <p className={cn('text-body-sm-medium text-alternative', disabled && 'text-disabled')}>
      {optionDescription}
    </p>;
  return <div className={cn('flex flex-col gap-2xs', disabled && 'text-disabled')} onClick={() => {
    !disabled && onToggle?.();
  }} data-sentry-component="ToggleOptionContainer" data-sentry-source-file="ToggleOptionContainer.tsx">
      <div className="flex flex-wrap items-center gap-2xs text-body-lg-bold">
        <div className={cn('flex flex-1 items-center gap-3xs', descriptionPlacement === 'text' && 'min-w-0 flex-col items-start gap-2xs')}>
          <div className="flex items-center gap-3xs">
            <div className="flex items-center gap-xs">
              {optionIcon}
              {optionTitle}
            </div>
            {isBadgeVisible && planType !== 'FREE' && (planType === 'PRO' ? <BoltFillColorVioletIcon size="xs" /> : <BoltFillColorMintIcon size="xs" />)}
            {isNew && <NewChip />}
          </div>
          {descriptionPlacement === 'text' && description}
        </div>
        {renderToggle ? renderToggle(toggle) : toggle}
      </div>
      {descriptionPlacement === 'below' && description}
    </div>;
};